module.exports = __webpack_public_path__ + "static/media/OspreyAI_Light.9e63af0e.png";